import { cn } from '@bem-react/classname';

export default cn('HistoryScreen');
